package com.essntl.features.itinerary.ui.edit_itinerary

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceFilterOptions
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceOrderType
import com.essntl.features.itinerary.domain.use_case.SortItineraryServices
import com.essntl.features.message.domain.model.MessageModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.request.domain.model.RequestModel
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.uikit.rememberContains
import com.essntl.uikit.rememberFind

@Composable
fun EditItineraryState.rememberProposal(itineraryId: String?): ProposalModel? {
    return rememberFind(
        getAllItinerary.data.orEmpty(),
        itineraryId,
    ) { itinerary -> itinerary.id }?.proposal
}

@Composable
fun EditItineraryState.rememberPrimaryClient(itineraryId: String?): ClientModel? {
    val proposal = rememberProposal(
        itineraryId = itineraryId,
    )

    return proposal?.primaryClient
}

@Composable
fun EditItineraryState.rememberTasks(itineraryServiceId: String): List<TaskModel> {
    return rememberContains(
        getAllItineraryServiceTask.data.orEmpty(),
        setOf(itineraryServiceId),
    ) {
        it.itineraryService?.id ?: ""
    }
}

@Composable
fun EditItineraryState.rememberCategory(id: String?): CategoryModel? {
    return rememberFind(
        getAllCategory.data.orEmpty(),
        id,
    ) { category -> category.id }
}

@Composable
fun EditItineraryState.rememberSortedItineraryServices(isConcierge: Boolean): List<ItineraryServiceModel> {
    return if (isConcierge) remember(getAllItineraryService.data, getAllClient.data, filterOptions) {
        SortItineraryServices(
            itineraryServices = getAllItineraryService.data,
            itineraries = getAllItinerary.data,
            clients = getAllClient.data,
            filterOptions = filterOptions,
        )
    } else remember(getAllItineraryService.data) {
        SortItineraryServices(
            itineraryServices = getAllItineraryService.data,
            filterOptions = ItineraryServiceFilterOptions(
                selectedItineraryServiceOrderType = ItineraryServiceOrderType.StartDateStartTime,
            ),
        )
    }
}

@Composable
fun EditItineraryState.rememberMessage(itineraryServiceId: String?): MessageModel? {
    return remember(
        itineraryServiceId,
        getAllMessages.data.orEmpty(),
    ) {
        getAllMessages.data
            .orEmpty()
            .lastOrNull { msg ->
                msg.type is MessageModel.Type.Whatsapp &&
                    msg.itineraryService?.id == itineraryServiceId
            }
    }
}
